<template>
  <div>
    <v-dialog v-model="dialog" width="680" persistent>
      <v-card>
        <v-card-title class="text-capitalize">{{ title }}</v-card-title>
        <div class="ma-4 mx-6">

          <div class="mb-4">
            <v-card-text class="pa-0 mt-2" v-if="content">
              {{ content }}
            </v-card-text>
          </div>

          <div class="mb-4">
            <v-card-text class="pa-0 mt-2" v-if="confirmationMessage">
              {{ confirmationMessage }}
            </v-card-text>
          </div>
        </div>

        <!-- modal action buttons -->
        <v-card-actions class="pa-4 px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn class="text-uppercase mr-4" text @click="closeModal">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn class="text-uppercase" color="primary" text @click="confirm">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    displayConfirmationDialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    },
    confirmationMessage: {
      type: String,
      required: false
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
    },
    confirm () {
      this.$emit('handle-confirmation', true)
      this.dialog = false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.displayConfirmationDialog
      },
      set (value) {
        this.$emit('update:displayConfirmationDialog', value)
      }
    }
  }
}
</script>
